<div class="nova-history-section">
  <div class="nova-history-header-section">
    <div class="left-section">
      <img src="assets/icons/navigator/nova-header-icon.svg" alt="nova-icon">
      <span>Nova</span>
    </div>

    <div class="right-section">
      <img src="assets/icons/navigator/toggle-icon.svg" alt="" (click)="closeNovaHistory()">
    </div>
  </div>

  <div class="nova-history-container">
    <div class="files-section"
         [class.active]="showSavedFiles"
         (click)="onSavedFilesClick()"
         (mouseenter)="isHoveringSavedFiles = true"
         (mouseleave)="isHoveringSavedFiles = false">
      <img *ngIf="showSavedFiles || isHoveringSavedFiles" src="assets/icons/navigator/selected-bookmark.svg" alt="Saved Files">
      <img *ngIf="!showSavedFiles && !isHoveringSavedFiles" src="assets/icons/navigator/unselected-bookmark.svg" alt="Saved Files">
      <span>Saved Files</span>
    </div>

    <div class="line"></div>

    <div class="conversation-section">
      <div class="conversation-header" [class.hidden]="isSearchOpen">
        <span>Conversations</span>
        <img *ngIf="!isSearchOpen"
             src="assets/icons/navigator/search.svg"
             alt="search"
             (click)="toggleSearch()">
      </div>

      <!-- Search Bar - overlaps conversation header -->
      <div *ngIf="isSearchOpen" class="search-bar-container">
        <div class="search-input-wrapper">
          <input type="text"
                 class="search-input"
                 placeholder="Search here..."
                 [value]="searchQuery"
                 (input)="onSearchInput($event)"
                 (keydown.escape)="clearSearch()">
          <img src="assets/icons/navigator/search-close.svg"
               alt="close search"
               class="search-close-icon"
               (click)="clearSearch()">
        </div>
      </div>

      <div class="conversation-list">
        <div *ngFor="let group of conversationGroups" class="conversation-group">
          <div class="group-header">{{ group.title }}</div>
          <div class="group-conversations">
            <div class="conversation-item"
                 *ngFor="let conversation of group.conversations; trackBy: trackByConversationId"
                 [class.active]="currentConversation?.id === conversation.id && !showSavedFiles"
                 [class.editing]="editingConversationId === conversation.id"
                 [attr.data-conversation-id]="conversation.id"
                 (click)="selectConversation(conversation.id, $event)">
              <div class="conversation-content">
                <div class="conversation-title"
                     [contentEditable]="editingConversationId === conversation.id"
                     (click)="onTitleClick($event)"
                     (blur)="saveConversationTitle(conversation.id, $event)"
                     (keydown.enter)="saveConversationTitleOnEnter(conversation.id, $event)"
                     (keydown.escape)="cancelEditConversation()">
                  {{ conversation.title.trim() || '...' }}
                </div>
                <!-- Conv Debugging -->
                <!-- <div class="conversation-timestamp" *ngIf="conversation.timestamp">
                  {{ conversation.timestamp | utcDateTime }}
                </div> -->
              </div>
              <div class="conversation-menu"
                   *ngIf="editingConversationId !== conversation.id"
                   (click)="toggleContextMenu(conversation.id, $event)">
                <button class="three-dot-btn" title="More options">
                  <img src="assets/icons/navigator/more-vert.svg" alt="more options">
                </button>

                <div class="context-menu"
                     *ngIf="showContextMenu === conversation.id"
                     (click)="$event.stopPropagation()">
                  <div class="context-menu-item" (click)="editConversation(conversation.id, $event)">
                    <img src="assets/icons/navigator/edit-icon.svg" alt="edit" class="menu-icon">
                    <span>Rename</span>
                  </div>
                  <div class="context-menu-item delete-item" (click)="confirmDeleteConversation(conversation.id, $event)">
                    <img src="assets/icons/navigator/delete-icon.svg" alt="delete" class="menu-icon">
                    <span>Delete</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
